import * as entropy from '../data/entropy.js'
import * as ui from '../ui.js'

export async function displayReportLocations() {
    const reportLocations = await entropy.initializeReportLocations()

    const reportLocationsElement = document.querySelector('mt-report-locations')

    reportLocationsElement.locations = reportLocations
    //validateSelectedLocations()

    const selections = reportLocations.filter((l) => l.isSelected === true)

    const generateReportElement = document.getElementById('js-generate-report')

    const results = {
        errorMessage:
            'Please select at least one location before running a report',
    }

    if (selections.length === 0) {
        ui.displayError({ results })
        generateReportElement.disabled = true
    } else {
        generateReportElement.disabled = false
        ui.hideErrors()
    }

    const mtReportLocations = document.querySelector('mt-report-locations')
    mtReportLocations.addEventListener('locationChange', handleLocationChange)
}

function handleLocationChange(e) {
    entropy.updateReportLocations({ locationId: Number(e.detail) })
    ui.removeReport()
    validateSelectedLocations(e)
}

// Put basic location validation logic in Location Component
async function validateSelectedLocations() {
    const selections = entropy.getSelectedReportLocations()
    const generateReportElement = document.getElementById('js-generate-report')

    const results = {
        errorMessage:
            'Please select at least one location before running a report',
    }

    if (selections.length === 0) {
        ui.displayError({ results })
        generateReportElement.disabled = true
    } else {
        generateReportElement.disabled = false
        ui.hideErrors()
    }
}
